import React, { useEffect, useState } from "react";
import {
    Eligibility, Height, Weight, BowelPrepPreference,
    Colonoscopy, DocumentUpload, Email,
    FamilyMemberDiagnosed, HealthConditionsPage,
    InsuranceCardInfo, LastColonoscopy, SearchMedications,
    SearchAllergiesToMedications,
    SuccessMsg,
    QuestionTypeNumber,
    NestedQuestion
} from './../../pages/questionnaire/questionnaireIndex';
import { useNavigate } from 'react-router-dom';


const Stepper = ({ step, handleNext, formValues, listOfQuestion, listOfAnswer, questionnairelist }) => {
    const navigate = useNavigate(); // Use useNavigate instead of useHistory
    const [isCallUS, setIsCallUS] = useState(false);

    useEffect(() => {
        let findIndex;
        const skippedQuestionIndex = localStorage.getItem('skippedQuestionIndex');
        if (skippedQuestionIndex && skippedQuestionIndex !== 'undefined') {
            findIndex = JSON.parse(skippedQuestionIndex);
        }
        setIsCallUS(findIndex === -1  ? true : false);
    }, []);

    const handleNextEvent = (step) => {
        if (step <= listOfAnswer?.length) {
            handleNext(step);
        } else {
            console.log('redirect');
            handleRedirectToPage();
        }
    };


    const handleRedirectToPage = () => {
        navigate('/visits');
    }

    const renderStep = (listOfQuestion) => {
        switch (listOfQuestion.questionType) {
            case 0: return <Eligibility handleNextEvent={handleNextEvent} formData={formValues} />;
            case 1: return <Colonoscopy handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} questionnairelist={questionnairelist} />;
            case 2: return <FamilyMemberDiagnosed handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 3: return <QuestionTypeNumber handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 4: return <LastColonoscopy handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />
            case 5: return <HealthConditionsPage handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 6: return <SearchMedications handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 7: return <Height handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 8: return <Weight handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 9: return <SearchAllergiesToMedications handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 10: return <SearchMedications handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} />;
            case 11: return <DocumentUpload handleNextEvent={handleNextEvent} formData={formValues} step={listOfQuestion.questionerIndex} questionData={listOfQuestion} />;
            case 12: return <DocumentUpload handleNextEvent={handleNextEvent} formData={formValues} step={listOfQuestion.questionerIndex} questionData={listOfQuestion} />;
            case 13: return <DocumentUpload handleNextEvent={handleNextEvent} formData={formValues} step={listOfQuestion.questionerIndex} questionData={listOfQuestion} />;
            case 14: return <Colonoscopy handleNextEvent={handleNextEvent} formData={formValues} questionData={listOfQuestion} questionnairelist={questionnairelist} />;

            case 15: return <NestedQuestion handleNextEvent={handleNextEvent} formData={formValues} step={listOfQuestion.questionerIndex} questionData={listOfQuestion} />
            case 16: return <NestedQuestion handleNextEvent={handleNextEvent} formData={formValues} step={listOfQuestion.questionerIndex} questionData={listOfQuestion} />
            case 20: return <SuccessMsg handleNextEvent={handleNextEvent} formData={formValues} isCallUS={isCallUS}/>;
            
            default:
                return <div>Invalid step</div>;
        }
    };

    return (
        <div>
            <div className={listOfQuestion.questionerIndex === 1 ? 'questionnaire-container margin-top-50' : 'question-container margin-top-50'}>
                {renderStep(listOfQuestion)}
            </div>
        </div>
    );
};

export default Stepper;